const controllers = {
  home: require('./views/home'),
  'products-show': require('./views/products-show'),
  carts: require('./views/carts'),
  dashboard: require('./views/dashboard'),
  'orders-show': require('./views/orders-show'),
  'orders-admin': require('./views/orders-admin'),
  'add-card': require('./views/add-card'),
  'confirm-card-payment': require('./views/confirm-card-payment'),
}

export default controllers
